import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from "@rails/request.js"

// Connects to data-controller="installment-prepare"
export default class extends Controller {
  static targets = ["treatmentNumber", "detailsContainer", "selectMonth","dateFirstRate","invoiceDate","form","dateFirstRateError","amount","errorMsg","invoiceDateError"]
  static classes = ["displayShow"]
  static outlets = ["installment-final"]

  connect() {
    this.calculatorState = 0; // invoice no needs to be checked
    this.conditionId = null
  }

  async submitPreview(event) {
    event.preventDefault()
    
    if(this.calculatorState == 0){
      this.restCheckInvoiceNo(this.treatmentNumberTarget.value)
    }else{
      this.restCalculate()
    }
    
  }

  async restCalculate(){
    const payload = {
      treatmentNumber: this.treatmentNumberTarget.value,
      dateFirstRate: this.dateFirstRateTarget.value,
      invoiceDate: this.invoiceDateTarget.value,
      amount: this.amountTarget.value,
      conditionId : this.conditionId,
      rates : this.selectMonthTarget.value
    }

    let valid = this.formTarget.reportValidity()
    if(valid == false){
      return
    }

    const request = new FetchRequest("post", '/api/v1/installment/calculate', { body: JSON.stringify(payload) })
    const response = await request.perform()
    if (response.ok) {
      const body = await response.json
      this.processResponseError(body)
      this.installmentFinalOutlet.show(body)
    }
  }

  async restCheckInvoiceNo(invoice_no) {
    const payload = { treatmentNumber: invoice_no }
    const request = new FetchRequest("post", '/api/v1/installment/check_invoice_no', { body: JSON.stringify(payload) })
    const response = await request.perform()
    if (response.ok) {
      const body = await response.json
      if (body.error == false && body.invoiceValid) {
        this.detailsContainerTarget.classList.add("displayShow")
        this.detailsContainerTarget.classList.remove("displayNone")

        this.conditionId = body.conditionId;

        for (var i = 1; i <= body.maxMonths; i++) {
          var opt = document.createElement('option');
          opt.value = i;
          opt.innerHTML = i;
          this.selectMonthTarget.appendChild(opt);
        }

        this.calculatorState = 1; // detail data must be entered
      }
      // Do whatever do you want with the response body
      // You also are able to call `response.html` or `response.json`, be aware that if you call `response.json` and the response contentType isn't `application/json` there will be raised an error.
    }
  }

  processResponseError(json_response){
    if(json_response.dateFirstRateError == true){
      this.dateFirstRateErrorTarget.classList.remove("displayNone")
    }else{
      this.dateFirstRateErrorTarget.classList.add("displayNone")
    }

    if(json_response.invoiceDateError == true){
      this.invoiceDateErrorTarget.classList.remove("displayNone")
    }else{
      this.invoiceDateErrorTarget.classList.add("displayNone")
    }

    if(json_response.error_msg){
      this.errorMsgTarget.innerHTML = "<strong>"+json_response.error_msg+"</strong>";
    }else{
      this.errorMsgTarget.innerHTML = ""
    }
  }
}
